import {
  setImportClientTypesActionType,
  setImportCombinationsActionType,
  setImportFAQsActionType,
  setImportKeywordsActionType,
  setImportStatusActionType,
  setImportSectionsActionType,
  setImportQuestionTypesActionType,
  setImportDateActionType,
  getImportFileDataActionType,
  getInitialDataActionType
} from "@/actionTypes/importActionTypes.ts";
import {
  IClientType,
  ICombination,
  IFAQ,
  IImportDate,
  IKeyword,
  ImportFileType,
  IQuestionType,
  ISection
} from "@/types/SPTypes.tsx";
import { DISPATCH_TYPE, IMPORT_STATUS } from "@/utils/enums.ts";

export const setImportClientTypesAction = (
  IClientTypes: IClientType[]
): setImportClientTypesActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_CLIENT_TYPES,
  payload: IClientTypes
});

export const setImportCombinationsAction = (
  ICombinations: ICombination[]
): setImportCombinationsActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_COMBINATIONS,
  payload: ICombinations
});

export const setImportFAQsAction = (
  IFAQs: IFAQ[]
): setImportFAQsActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_FAQS,
  payload: IFAQs
});

export const setImportKeywordsAction = (
  IKeywords: IKeyword[]
): setImportKeywordsActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_KEYWORDS,
  payload: IKeywords
});

export const setImportStatusAction = (
  importStatus: IMPORT_STATUS
): setImportStatusActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_STATUS,
  payload: importStatus
});

export const setImportSectionsAction = (
  ISections: ISection[]
): setImportSectionsActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_SECTIONS,
  payload: ISections
});

export const setImportQuestionTypesAction = (
  IQuestionTypes: IQuestionType[]
): setImportQuestionTypesActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_QUESTION_TYPES,
  payload: IQuestionTypes
});

export const setImportDateAction = (
  IImportDates: IImportDate[]
): setImportDateActionType => ({
  type: DISPATCH_TYPE.SET_IMPORT_DATE,
  payload: IImportDates
});

export const getImportFileDataAction = (
  importFile: ImportFileType
): getImportFileDataActionType => ({
  type: DISPATCH_TYPE.GET_IMPORT_FILE_DATA,
  payload: importFile
});

export const getInitialDataAction = (): getInitialDataActionType => ({
  type: DISPATCH_TYPE.GET_INITIAL_DATA
});
